import {
  BORDER_COLOR_SHADE_2,
  DARKER_GREY,
  PRIMARY_BLUE,
  GRAY_DARK_SHADE_2,
  WHITE,
} from '~/Constants/Colors.constants';
import { TRANSITION_MATERIAL } from '~/Constants/CSS.constants';
import { FONT_SIZE_MEDIUM, FONT_SIZE_SMALL, FONT_SIZE_XS } from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';

export const ItemCreationToolbarStyles = makeStyles((theme) => ({
  ItemCreationToolbarContainer: {
    display: 'flex',
    borderBottom: `thin solid ${BORDER_COLOR_SHADE_2}`,
    minHeight: 50,
    background: WHITE,
  },
  ItemCreationToolbarMobile: {
    background: GRAY_DARK_SHADE_2,
    borderBottom: `thin solid ${BORDER_COLOR_SHADE_2}`,
    placeContent: 'space-around',
  },
  ItemCreationToolbarSection: {
    color: DARKER_GREY,
    transition: `color ${TRANSITION_MATERIAL}`,
    display: 'flex',
    flexDirection: 'column',
    '&.active, &:active': {
      color: PRIMARY_BLUE,
    },
    '& > svg': {
      height: 20,
      width: 20,
    },
  },
  ItemCreationToolbarSectionDesktop: {
    padding: theme.spacing(1),
    marginRight: '30px',
    '&.active, &:active': {
      borderBottom: `3px solid ${PRIMARY_BLUE}`,
    },
    '& > .MuiButton-label': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  ItemCreationToolbarSectionCheckMark: {
    verticalAlign: 'middle',
  },
  ItemCreationToolbarSectionTitle: {
    fontSize: FONT_SIZE_MEDIUM,
    fontWeight: 'bold',
    lineHeight: '13px',
    textAlign: 'center',
    color: 'inherit',
    marginTop: 5,
  },
  ItemCreationToolbarSectionTitleMobile: {
    fontSize: FONT_SIZE_XS,
    [theme.breakpoints.down('md')]: {
      '& > svg': {
        fontSize: FONT_SIZE_SMALL,
      },
    },
  },
}));
